(function($) {

var pageId = 'page-folder',
	page = '#' + pageId;

$(function() {
	$(document).on('click', page + ' .detail-action-edit', function(e) {
		e.preventDefault();
		$('.crumb .current-dir').trigger('click');

	}).on('click', page + ' .crumb .current-dir', function(e) {
		var $name = $(this).hide();
		var $btnGroup = $name.closest('.crumb').siblings('.btn-group').hide();
		$btnGroup.siblings('.rename-dir').show()
			.find('#txt-dir-name')
			.val($name.text())
			.focus()
			.select();
	}).on('click', page + ' #link-cancel-rename', function(e) {
		var $link = $(this);
		var $rename = $(this).closest('.rename-dir').hide();
		$rename.siblings('.btn-group').show();
		$rename.siblings('.crumb').find('.current-dir').show();
	}).on('keydown', page + ' #txt-dir-name', function(e) {
		if (e.which == 27) {
			$(page).find('#link-cancel-rename').trigger('click');
			return false;
		} else if (e.which == 13) {
			$(page).find('#btn-rename-dir').trigger('click');
			return false;
		}
	}).on('ajax:success', page + ' .rename-dir form', function(e) {
		var name = $('#txt-dir-name').val();
		$(page).find('.crumb .current-dir').show().text(name);
		$(page).find('.rename-dir').hide()
			.siblings('.btn-group').show();
	}).on('ajax:beforeSend', page + ' .detail-action-del', function(e) {
		simple.loading({
		type: 'global',
			msg: '正在删除文件夹...'
		});
	}).on('ajax:complete', page + ' .detail-action-del', function(e) {
		simple.loading.destroy();
	});
});

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    tower.initFileUpload({
        params: {
            dir_guid: $page.data('dir-guid')
        }
    });
    tower.initFileViews();
    tower.initFileDnD($page);

    var $filesView = $page.find('.files-view');
    simple.filedrop({
        el: $filesView.is(':visible') ? $filesView : $page,
        hints: '拖拽到这里上传'
    }).on('drop', function(e, files) {
        var $btn = $('.btn-upload-file');
        var uploader = $btn.data('uploader');

        if (!tower.isScreenView($btn)) {
            simple.scrollTo({target:$btn});
        }

        if (files) {
            $.each(files, function (i, file) {
                uploader.upload(file);
            });
        }
    });
});


})(jQuery);
